import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { AppMedia, AppLink } from './'
import state from '../store/store';

interface SectionAssociationsCTA {
    __component: string;
    data?: any;
}

export const SectionAssociationsCTA: FunctionalComponent<SectionAssociationsCTA> = ({ data }) => {


    const { Title, brands, RemoveTopMargin } = data;
    const useDefault = isEmpty(get(brands, 'data'))
    const DefaultBrands = get(state.website, 'DefaultBrands.brands.data') || [];
    const BrandCards = (useDefault ? DefaultBrands : (get(brands, 'data') || [])).map(({ attributes }) => attributes);
    const howardsonLink = { 'URL': 'https://howardsongroup.com', Alt: 'Howardson Group' }


    return (
        <section class={`uk-section ${RemoveTopMargin ? 'uk-padding-remove-top' : ''}`}>
            <div class="uk-container">
                <div hidden={!Title} class="uk-text-center uk-margin-small-top">
                    <h2 class="uk-heading-small uk-margin-small-bottom wsio-gold">{Title}</h2>
                    <hr class="uk-divder-slashed uk-width-1-2 uk-width-1-4@m uk-width-1-5@l uk-margin-medium-bottom@s" />
                </div>
                <div hidden={!useDefault}>
                    <div class="uk-margin-medium-bottom uk-flex uk-flex-center uk-flex-wrap uk-flex-wrap-around uk-flex-wrap-middle">
                        <AppLink className='uk-margin-bottom uk-button uk-button-link' data={howardsonLink}>
                            <img class="uk-preserve uk-width-large uk-position-z-index" src="/assets/images/howardson.svg" aria-label="Howardson Group Logo" alt="Howardson Group Logo" uk-svg></img>
                        </AppLink>
                    </div>
                    {/* <hr class="uk-divder-slashed uk-margin-large-left uk-margin-large-right" style={{ 'border-color': '#f5f5f5', 'border-width': '2px' }} /> */}
                </div>
                <div class="uk-container uk-container-small uk-margin-medium-top uk-flex uk-flex-center uk-flex-wrap uk-flex-wrap-around uk-flex-wrap-middle">
                    {
                        BrandCards.map(({ Link, Logo }) => {
                            return [
                                <div class="uk-width-1-1 uk-width-1-3@s uk-width-1-5@m uk-padding-small uk-padding-remove-top uk-flex uk-flex-middle uk-flex-center">
                                    <div class="">
                                        <AppLink className='uk-button uk-button-link uk-animation-toggle' data={Link}>
                                            <AppMedia className='uk-padding-small' size="(max-width: 638px) 50vw, (max-width: 958px) 30vw, 20vw" media={Logo} />
                                            {/* <div class="uk-text-small uk-hidden uk-animation-fade">{Link.Label}</div> */}
                                        </AppLink>
                                    </div>
                                </div>
                            ]
                        })
                    }
                </div>
            </div>
        </section >
    )
};